import { noop } from 'lodash'
import React from 'react'

type TUserOption = {
  value: { roles: string[]; settingId: number }
  label: string
}
type TGlobalUserSelect = {
  value?: number
  userOptions?: TUserOption[]
  onChange?: (val?: number) => void
}

const GlobalUserContext = React.createContext<TGlobalUserSelect>({
  value: 1,
  onChange: noop,
  userOptions: [
    { value: { roles: ['admin'], settingId: 1 }, label: 'Admin' },
    {
      value: { roles: ['tenantAdmin'], settingId: 2 },
      label: 'Tenant Admin',
    },
    { value: { roles: ['user'], settingId: 3 }, label: 'User' },
    { value: { roles: ['translator'], settingId: 4 }, label: 'Translator' },
  ],
})

export default GlobalUserContext
